"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardFilterReferenceObjRef = exports.isDashboardAttributeFilterReference = exports.isDashboardDateFilterReference = exports.isTempFilterContext = exports.isFilterContext = exports.isFilterContextDefinition = exports.isAllTimeDashboardDateFilter = exports.newAllTimeDashboardDateFilter = exports.newAbsoluteDashboardDateFilter = exports.newRelativeDashboardDateFilter = exports.isDashboardDateFilter = exports.isDashboardAttributeFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardAttributeFilter}.
 * @alpha
 */
function isDashboardAttributeFilter(obj) {
    return !isEmpty_1.default(obj) && !!obj.attributeFilter;
}
exports.isDashboardAttributeFilter = isDashboardAttributeFilter;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardDateFilter}.
 * @alpha
 */
function isDashboardDateFilter(obj) {
    return !isEmpty_1.default(obj) && !!obj.dateFilter;
}
exports.isDashboardDateFilter = isDashboardDateFilter;
/**
 * Creates a new relative dashboard date filter.
 *
 * @param granularity - granularity of the filters (month, year, etc.)
 * @param from - start of the interval – negative numbers mean the past, zero means today, positive numbers mean the future
 * @param to - end of the interval – negative numbers mean the past, zero means today, positive numbers mean the future
 * @alpha
 */
function newRelativeDashboardDateFilter(granularity, from, to) {
    return {
        dateFilter: {
            type: "relative",
            granularity: granularity,
            from: from,
            to: to,
        },
    };
}
exports.newRelativeDashboardDateFilter = newRelativeDashboardDateFilter;
/**
 * Creates a new absolute dashboard date filter.
 *
 * @param from - start of the interval in ISO-8601 calendar date format
 * @param to - end of the interval in ISO-8601 calendar date format
 * @alpha
 */
function newAbsoluteDashboardDateFilter(from, to) {
    return {
        dateFilter: {
            type: "absolute",
            granularity: "GDC.time.date",
            from: from,
            to: to,
        },
    };
}
exports.newAbsoluteDashboardDateFilter = newAbsoluteDashboardDateFilter;
/**
 * Creates a new all time date filter. This filter is used to indicate that there should be no filtering on the dates.
 *
 * @alpha
 */
function newAllTimeDashboardDateFilter() {
    return {
        dateFilter: {
            type: "relative",
            granularity: "GDC.time.date",
        },
    };
}
exports.newAllTimeDashboardDateFilter = newAllTimeDashboardDateFilter;
/**
 * Type-guard testing whether the provided object is an All time dashboard date filter.
 * @alpha
 */
function isAllTimeDashboardDateFilter(obj) {
    return isDashboardDateFilter(obj) && isNil_1.default(obj.dateFilter.from) && isNil_1.default(obj.dateFilter.to);
}
exports.isAllTimeDashboardDateFilter = isAllTimeDashboardDateFilter;
/**
 * Type-guard testing whether the provided object is an instance of {@link IFilterContextDefinition}.
 * @alpha
 */
function isFilterContextDefinition(obj) {
    // Currently, we have no better way to distinguish between IFilterContext and ITempFilterContext
    return hasFilterContextBaseProps(obj) && !sdk_model_1.isObjRef(obj.ref);
}
exports.isFilterContextDefinition = isFilterContextDefinition;
/**
 * Type-guard testing whether the provided object is an instance of {@link IFilterContext}.
 * @alpha
 */
function isFilterContext(obj) {
    // Currently, we have no better way to distinguish between IFilterContext and ITempFilterContext
    return hasFilterContextBaseProps(obj) && sdk_model_1.isObjRef(obj.ref);
}
exports.isFilterContext = isFilterContext;
/**
 * Type-guard testing whether the provided object is an instance of {@link ITempFilterContext}.
 * @alpha
 */
function isTempFilterContext(obj) {
    // Currently, we have no better way to distinguish between IFilterContext and ITempFilterContext
    return (hasFilterContextBaseProps(obj) &&
        sdk_model_1.isObjRef(obj.ref) &&
        !obj.identifier &&
        !obj.title);
}
exports.isTempFilterContext = isTempFilterContext;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardDateFilterReference}.
 * @alpha
 */
function isDashboardDateFilterReference(obj) {
    return !isEmpty_1.default(obj) && obj.type === "dateFilterReference";
}
exports.isDashboardDateFilterReference = isDashboardDateFilterReference;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardAttributeFilterReference}.
 * @alpha
 */
function isDashboardAttributeFilterReference(obj) {
    return !isEmpty_1.default(obj) && obj.type === "attributeFilterReference";
}
exports.isDashboardAttributeFilterReference = isDashboardAttributeFilterReference;
/**
 * Gets reference to object being used for filtering. For attribute filters, this will be reference to the display
 * form. For date filters this will be reference to the data set.
 *
 * @alpha
 */
function dashboardFilterReferenceObjRef(ref) {
    return isDashboardAttributeFilterReference(ref) ? ref.displayForm : ref.dataSet;
}
exports.dashboardFilterReferenceObjRef = dashboardFilterReferenceObjRef;
/**
 * @internal
 */
function hasFilterContextBaseProps(obj) {
    return !isEmpty_1.default(obj) && !!obj.filters;
}
//# sourceMappingURL=filterContext.js.map